<!-- 时间选择组件 -->
<template>
    <div class="timeSelect_Wrap flex_align">
        <ul class="timeSelectList">
            <li
                class="item"
                :class="{'active':time.value==activeTime}"
                v-for="(time,index) in timeList" :key="index"
                @click="selectTime(time.value)">
                {{time.label}}
            </li>
        </ul>
        <div class="diytime ml_15">
            <!-- <el-input
                placeholder="自定义时间"
                suffix-icon="el-icon-date"
                v-model="diyTime">
            </el-input> -->
            <el-date-picker
                :clearable="false"
                v-model="diyTime"
                type="daterange"
                range-separator="-"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                @change="changeDate">
            </el-date-picker>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                activeTime:'',
                diyTime:[],//自定义时间
            }
        },
        props:{
            timeList:{
                type:Array,
                default(){
                    return [
                        {value:0,label:'近7天'},
                        {value:1,label:'近1个月'},
                        {value:2,label:'近6个月'},
                        {value:3,label:'近12个月'},
                    ];
                }
            },
            diyTimeProp:{
                type:Array,
                default(){
                    return [];
                }
            },
            activeTimeProp:{
                default(){
                    return '';
                }
            },
        },
        computed: {
            selectedTimeObj(){
                return {
                    activeTime:this.activeTime,
                    diyTime:this.diyTime,
                }
            }
        },
        watch: {
            timeList(){
                console.log('timeList')
                this.activeTime=this.timeList[0].value
            },
            diyTime(newval,oldval){
                console.log('diyTime','oldval:'+oldval,'newval:'+newval)
                if(this.diyTime&&this.diyTime.length){
                    this.activeTime=4
                }else{
                    // if(oldval.length&&!newval.length){
                        // this.activeTime=this.timeList[0].value
                    // }
                }
            },
            activeTime(newval,oldval){
                console.log('activeTime','oldval:'+oldval,'newval:'+newval)
                if(oldval==4){
                    this.diyTime=[]
                }
                this.$emit('selectTime',this.selectedTimeObj);
            },
        },
        created() {
            if(this.activeTimeProp==''){
                this.activeTime=this.timeList[0].value
            }else{
                this.activeTime=this.activeTimeProp
            }
            if(this.diyTimeProp.length&&this.diyTimeProp[0]!=''&&this.diyTimeProp[1]!=''){
                this.activeTime=4
                this.diyTime=this.diyTimeProp
            }
        },
        methods: {
            selectTime(val){
                // console.log(val)
                this.activeTime=val
            },
            changeDate(val){
                // console.log(val,this.diyTime,this.activeTime)
                this.$emit('selectTime',this.selectedTimeObj);
            }
        }
    }
</script>

<style lang="scss" scoped>
.timeSelect_Wrap{
    height: .32rem;
    .timeSelectList{
        box-sizing: border-box;
        border: .01rem solid #EAEAEA;
        height: .32rem;
        line-height: .32rem;
        border-radius: .04rem;
        display: inline-block;
        .item{
            float: left;
            padding: 0 .2rem;
            font-size: .14rem;
            color: #354052;
            cursor: pointer;
            &.active{
                background:linear-gradient(0deg,#0086B6,#00a4df);
                color: white;
            }

            &:first-child{
                border-radius: .04rem 0 0 .04rem;
            }
            &:last-child{
                border-radius: 0 .04rem .04rem 0;
            }
        }
    }
}
</style>
